import { CallEffect, ForkEffect, GetContextEffect, PutEffect } from 'redux-saga/effects';
import { getContext, call, put, takeLatest } from 'typed-redux-saga';
import {
  IGetFleetOperatingTimeErrorAction,
  IGetFleetOperatingTimeRequestAction,
  IGetFleetOperatingTimeSuccessAction,
  FleetOperatingTimeActions,
} from './fleetOperatingTimeActions';
import { IDependencies } from 'app/cross-cutting-concerns/dependency-injection/interfaces/IDependencies';
import { FleetOperatingTimeResponse } from 'app/modules/machine-inventory/interfaces/Machine.types';

export function* getFleetOperatingTimeSaga(
  action: IGetFleetOperatingTimeRequestAction
): Generator<
  | GetContextEffect
  | CallEffect<FleetOperatingTimeResponse>
  | PutEffect<IGetFleetOperatingTimeSuccessAction>
  | PutEffect<IGetFleetOperatingTimeErrorAction>,
  void,
  IDependencies
> {
  const { machineService } = yield* getContext<IDependencies>('dependencies');

  try {
    const response = yield* call(machineService.getFleetOperatingTime, action.payload);
    yield* put(FleetOperatingTimeActions.getFleetOperatingTimeSuccess(response));
  } catch (error) {
    yield* put(
      FleetOperatingTimeActions.getFleetOperatingTimeError({
        error,
      })
    );
  }
}

export function* fleetOperatingTimeSaga(): Generator<ForkEffect<never>, void> {
  yield* takeLatest(FleetOperatingTimeActions.GET_FLEET_OPERATING_TIME_REQUEST, getFleetOperatingTimeSaga);
}
